<template>
	<div class="content">
		<!-- <div class="tip">
		  <span>发票明细</span>
		</div> -->
    <van-form ref="detailForm" :disabled="isEdit">
      <div v-if="type == 'vat_invoice'">
        <van-field v-model="invoice[index].detailno" name="编号" label="编号" placeholder="编号"
                   :rules="[{ required: true, message: '请填写编号' }]"
        />
        <van-field v-model="invoice[index].name" name="名称" label="名称" placeholder="名称"
                   :rules="[{ required: true, message: '请填写名称' }]"
        />
        <van-field v-model="invoice[index].type" name="规格" label="规格" placeholder="规格"
        />
        <van-field v-model="invoice[index].unit" name="单位" label="单位" placeholder="单位"
        />
        <van-field v-model="invoice[index].num" name="数量" label="数量" placeholder="数量" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写数量' }]"
        />
        <van-field v-model="invoice[index].price" name="单价" label="单价" placeholder="单价" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写单价' }]"
        />
        <van-field v-model="invoice[index].amount" name="金额" label="金额" placeholder="金额" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写金额' }]"
        />
        <van-field v-model="invoice[index].taxRate" name="税率" label="税率" placeholder="税率"
                   :rules="[{ required: true, message: '请填写税率' }]"
        />
        <van-field v-model="invoice[index].tax" name="税额" label="税额" placeholder="税额" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写税额' }]"
        />
      </div>
      <div v-if="type == 'roll_normal_invoice'">
        <van-field v-model="invoice[index].name" name="货物名称" label="货物名称" placeholder="货物名称"
                   :rules="[{ required: true, message: '请填写货物名称' }]"
        />
        <van-field v-model="invoice[index].num" name="数量" label="数量" placeholder="数量" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写数量' }]"
        />
        <van-field v-model="invoice[index].price" name="单价" label="单价" placeholder="单价" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写单价' }]"
        />
        <van-field v-model="invoice[index].amount" name="金额" label="金额" placeholder="金额" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写金额' }]"
        />
      </div>
      <div v-if="type == 'printed_invoice'">
        <van-field v-model="invoice[index].name" name="货物名称" label="货物名称" placeholder="货物名称"
                   :rules="[{ required: true, message: '请填写货物名称' }]"
        />
        <van-field v-model="invoice[index].unit" name="单位" label="单位" placeholder="单位" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写单位' }]"
        />
        <van-field v-model="invoice[index].num" name="数量" label="数量" placeholder="数量" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写数量' }]"
        />
        <van-field v-model="invoice[index].price" name="单价" label="单价" placeholder="单价" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写单价' }]"
        />
        <van-field v-model="invoice[index].amount" name="金额" label="金额" placeholder="金额" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写金额' }]"
        />
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">货物名称</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].name"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">单位</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].unit"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">数量</span>-->
        <!--				<input class="input" type="span"  @input="checkAmount('printed_invoice',invoice[index].num,invoice[index].price,invoice[index].amount)" v-model="invoice[index].num"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">单价</span>-->
        <!--				<input class="input" type="digit"  @input="checkAmount('printed_invoice',invoice[index].num,invoice[index].price,invoice[index].amount)" v-model="invoice[index].price"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">金额</span>-->
        <!--				<input class="input" type="digit"  @input="checkAmount('printed_invoice',invoice[index].num,invoice[index].price,invoice[index].amount)" v-model="invoice[index].amount"/>-->
        <!--			</div>-->
      </div>
      <div v-if="type == 'taxi_online_ticket'">
        <van-field v-model="invoice[index].pickupDate" name="上车日期" label="上车日期" placeholder="上车日期"
                   :rules="[{ required: true, message: '请填写上车日期' }]"
        />
        <van-field v-model="invoice[index].pickupTime" name="上车时间" label="上车时间" placeholder="上车时间"
                   :rules="[{ required: true, message: '请填写上车时间' }]"
        />
        <van-field v-model="invoice[index].carType" name="车型" label="车型" placeholder="车型"
                   :rules="[{ required: true, message: '请填写车型' }]"
        />
        <van-field v-model="invoice[index].distance" name="里程" label="里程" placeholder="里程"
                   :rules="[{ required: true, message: '请填写里程' }]"
        />
        <van-field v-model="invoice[index].startPlace" name="起点" label="起点" placeholder="起点"
                   :rules="[{ required: true, message: '请填写起点' }]"
        />
        <van-field v-model="invoice[index].destinationPlace" name="终点" label="终点" placeholder="终点"
                   :rules="[{ required: true, message: '请填写终点' }]"
        />
        <van-field v-model="invoice[index].city" name="城市" label="城市" placeholder="城市"
                   :rules="[{ required: true, message: '请填写城市' }]"
        />
        <van-field v-model="invoice[index].fare" name="金额" label="金额" placeholder="金额" type="number" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写金额' }]"
        />
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">上车日期</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].pickupDate"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">上车时间</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].pickupTime"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">车型</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].carType"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">里程</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].distance"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">起点</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].startPlace"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">终点</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].destinationPlace"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">城市</span>-->
        <!--				<input class="input" type="span" v-model="invoice[index].city"/>-->
        <!--			</div>-->
        <!--			<div class="row b-b">-->
        <!--				<span class="tit">金额</span>-->
        <!--				<input class="input" type="digit" v-model="invoice[index].fare"/>-->
        <!--			</div>-->
      </div>
    </van-form>

		<div style="position:absolute; left: 0; bottom: 0; width: 100%;" v-if="edit">
		  <van-button size="large" type="info" @click="save()">确定</van-button>
		</div>
	</div>
</template>

<script>
  import Decimal from "decimal.js";
	export default {
	  props: {
	    edit: {
	      type: Boolean,
        default: true
      }
    },
		data() {
			return {
				index:0,
				type: '',
				invoice: [],
        isEdit: true,
			}
		},
		created() {
		  // this.invoice = JSON.parse(decodeURIComponent(this.$route.query.data))
		  // this.index = this.$route.query.index;
		  // this.type = this.$route.query.type;
		},
		methods: {
			init(type, index, detail, isEdit = true){
			  this.isEdit = isEdit
				this.invoice = JSON.parse(decodeURIComponent(detail))
				this.index = index;
				this.type = type;
			},
			checkAmount(type,num, nuitPrice, amount){
				if((num * parseFloat(nuitPrice)) != parseFloat(amount)){
				  this.$toast.fail('金额之和错误')
				}
			},
			save(){
			  // if(this.type === 'roll_normal_invoice') {
        //   // console.log(new Decimal(this.invoice[this.index].num).mul(this.invoice[this.index].price).toFixed(2, Decimal.ROUND_DOWN), '1212')
        //   // console.log(new Decimal(this.invoice[this.index].amount).toFixed(2, Decimal.ROUND_DOWN), '2323')
			  //   if(new Decimal(this.invoice[this.index].num).mul(this.invoice[this.index].price).toFixed(2, Decimal.ROUND_DOWN) !== new Decimal(this.invoice[this.index].amount).toFixed(2, Decimal.ROUND_DOWN)) {
			  //     this.$toast.fail('金额之和错误')
        //     return
        //   }
        // }
        this.$refs.detailForm.validate().then(res => {
          this.$emit("childSave", this.index, this.invoice[this.index])
        })
			},
      formatterNumber(value){
        return Number(value).toFixed(2)
      },
      changeRollAmount(){
        this.invoice[this.index].num = new Decimal(this.invoice[this.index].num).toFixed(2, Decimal.ROUND_DOWN)
        this.invoice[this.index].price = new Decimal(this.invoice[this.index].price).toFixed(2, Decimal.ROUND_DOWN)
			  this.invoice[this.index].amount = new Decimal(this.invoice[this.index].num).mul(this.invoice[this.index].price).toFixed(2, Decimal.ROUND_DOWN)
      },
      onConfirm(){

      }
		}
	}
</script>

<style scoped>
	.content{
		width: 98%;
		margin: 5px auto;
    position: relative;
	}
  .tip{
    padding: 5px 10px;
    background-color: #EEEEEE;
    font-weight: bold;
  }
	.row{
		display: flex;
		align-items: center;
		padding:0 10px;
		height: 35px;
		background-color: #FFFFFF;
		border-bottom: 1px solid #EEEEEE;
	}
  .tit{
    width: 80px;
    font-size: 15px;
    color: #000000;
  }
  .input{
    font-size:15px;
    color: #828E95;
    width: calc(100% - 85px);
    text-align: right;
  }
</style>
